import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NbThemeModule, NbLayoutModule, NbSpinnerModule, NbSidebarModule, NbMenuModule, NB_JS_THEMES, NB_THEME_OPTIONS } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CoreModule } from './modules/core/core.module';
import { RouterModule } from '@angular/router';
import { StorageService } from './modules/shared/services/storage.service';
import { LanguageLoader } from './modules/core/loaders/language-loader';
import { SharedModule } from '@shared/shared.module';
import { UserService } from '@shared/modules/account/services/user.service';
import { SignalRService } from '@shared/services/signal-r.service';
import { NotificationSignalRService } from '@notifications/services/notification-signal-r.service';
import { GoogleDriveAuthConfigModule } from '@googleDriveAuthConfig/google-drive-auth-config.module';
import { baseTheme } from '@shared/styles/base.theme';
import { clinicalTheme } from '@shared/styles/clinical.theme';
import { ThemeHelper } from '@shared/helpers/theme.helper';
import { PreviewModule } from '@preview/preview.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    RouterModule,
    NbThemeModule.forRoot(),
    NbLayoutModule,
    NbEvaIconsModule,
    NbSidebarModule.forRoot(),
    NbSpinnerModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient, StorageService]
      }
    }),
    CoreModule,
    NbMenuModule.forRoot(),
    GoogleDriveAuthConfigModule,
    PreviewModule
  ],
  providers: [
    {
      provide: NB_THEME_OPTIONS,
      useValue: { name: ThemeHelper.theme }
    },
    { 
      provide: NB_JS_THEMES,
      useValue: [
        { name: 'roboze_incloud', base: 'corporate', variables: baseTheme },
        { name: 'roboze_incloud_clinical', base: 'roboze_incloud', variables: clinicalTheme },
      ]
    },
    { provide: LOCALE_ID, deps: [HttpClient, StorageService], useFactory: setLanguage },
    { provide: APP_INITIALIZER, useFactory: loginUser, deps: [UserService, SignalRService, NotificationSignalRService], multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function httpLoaderFactory(http: HttpClient, storageService: StorageService) {
  return new LanguageLoader(http, storageService);
}

export function loginUser(userService: UserService, signalRService: SignalRService, notificationSignalRService: NotificationSignalRService) {
  return async () => {
    const isLogged = await userService.updateUserData();

    if (isLogged) {
      signalRService.userAuthorization = () => userService.currentUserValue;
      signalRService.startConnection();
      //notificationSignalRService.startConnection();
    }

    return isLogged;
  }
}

export function setLanguage(http: HttpClient, storageService: StorageService) {
  return new LanguageLoader(http, storageService).setLanguage();
}